import React, { useState } from 'react'
import logo from '../images/ex-logo.png'
const Logo = () => {
    const [partner, setPartner] = useState('white')

    return (
        <div className="navbar-brand-box">
            {
                partner !== "white" ? <>
                    <a href="" className="logo logo-dark">
                        <span className="logo-sm">
                            <img src={logo} alt="" />
                        </span>
                        <span className="logo-lg">
                            <img src={logo} alt="" />
                        </span>
                    </a>
                    <a href="" className="logo logo-light">
                        <span className="logo-sm">
                            <img src={logo} alt="" height="22" />
                        </span>
                        <span className="logo-lg">
                            <img src={logo} alt="" height="20" />
                        </span>
                    </a>
                </> : <>
                    <a href="/" className="logo-i95">
                        <span className="logo-i95-line"><span className="highlight">Passionate</span> about</span>
                        <span className="logo-i95-line">eCommerce</span>
                    </a>
                </>
            }
            
        </div>
    )
}

export default Logo
